import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom"
import {Provider} from 'react-redux'
import store from './store/store'
import { LicenseInfo } from '@mui/x-license';


// Set the license key for DataGridPro
//LicenseInfo.setLicenseKey("80d295f1650081f5914374614a2d0485Tz0xMTcwNTgsRT0xNzg1NzE1MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");
//if (process.env.NODE_ENV === 'production') {
 // }
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <Provider store={store}>
        <meta httpEquiv="cache-control" content="no-cache" />
        <meta httpEquiv="pragma" content="no-cache" />
        <App />
    </Provider>

);